module.exports = __webpack_public_path__ + "img/img8.f0759aac.jpg";